export enum PlayerPositionDBChoices {
    goalKeeper = 'gk',
    fullBack = 'fb',
    centreBack = 'cb',
    sweeper = 'sw',
    defensiveMidfielder = 'dm',
    centralMidfielder = 'cm',
    striker = 'st',
    attackingMidfielder = 'am',
}

export enum PlayerPositionUIChoices {
    goalKeeper = 'Goal Keeper',
    fullBack = 'Full Back',
    centreBack = 'Centre Back',
    sweeper = 'Sweeper',
    defensiveMidfielder = 'Defensive Midfield',
    centralMidfielder = 'Central Midfield',
    attackingMidfielder = 'Attacking Midfield',
    striker = 'Striker',
}

export const PlayerPositionSelectChoices = [
  { label: PlayerPositionUIChoices.goalKeeper, value: PlayerPositionDBChoices.goalKeeper},
  { label: PlayerPositionUIChoices.centreBack, value: PlayerPositionDBChoices.centreBack},
  { label: PlayerPositionUIChoices.fullBack, value: PlayerPositionDBChoices.fullBack},
  { label: PlayerPositionUIChoices.defensiveMidfielder, value: PlayerPositionDBChoices.defensiveMidfielder},
  { label: PlayerPositionUIChoices.centralMidfielder, value: PlayerPositionDBChoices.centralMidfielder},
  { label: PlayerPositionUIChoices.attackingMidfielder, value: PlayerPositionDBChoices.attackingMidfielder},
  { label: PlayerPositionUIChoices.striker, value: PlayerPositionDBChoices.striker}
];
